import {
  Activity,
  Building2,
  FileText,
  Eye,
  FlaskConical,
  Inbox,
  Languages,
  ListTree,
  ScrollText,
  Send,
  Server,
  Settings,
  Wallet,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type NavSection = 'primary' | 'org' | 'ops'

export interface NavItem {
  to: string
  labelKey: string
  icon: LucideIcon
  /** Restrict to super_admin only. */
  superAdminOnly?: boolean
  /** Visual grouping in the sidebar. */
  section: NavSection
}

/**
 * Product nav — primary client routes, then ops (research/ops for all admins;
 * tenants/audit super_admin-only), then Paramètres at the bottom.
 */
export const navItems: NavItem[] = [
  { to: '/desk', labelKey: 'nav.desk', icon: Inbox, section: 'primary' },
  { to: '/articles', labelKey: 'nav.articles', icon: FileText, section: 'primary' },
  { to: '/topics', labelKey: 'nav.topics', icon: ListTree, section: 'primary' },
  { to: '/deliveries', labelKey: 'nav.deliveries', icon: Send, section: 'primary' },
  { to: '/settings', labelKey: 'nav.settings', icon: Settings, section: 'org' },
  // Research + Ops stay available to every authenticated admin (pre-B2B behaviour).
  // Only Tenants / Locale audit / Audit remain super_admin-only.
  { to: '/research', labelKey: 'nav.research', icon: FlaskConical, section: 'ops' },
  { to: '/seo/geo', labelKey: 'nav.seoGeo', icon: Eye, section: 'ops' },
  { to: '/seo/spend', labelKey: 'nav.seoSpend', icon: Wallet, section: 'ops' },
  {
    to: '/seo/platform',
    labelKey: 'nav.seoPlatform',
    icon: Server,
    section: 'ops',
    superAdminOnly: true,
  },
  { to: '/ops', labelKey: 'nav.ops', icon: Activity, section: 'ops' },
  {
    to: '/tenants',
    labelKey: 'nav.tenants',
    icon: Building2,
    section: 'ops',
    superAdminOnly: true,
  },
  {
    to: '/locale-audit',
    labelKey: 'nav.localeAudit',
    icon: Languages,
    section: 'ops',
    superAdminOnly: true,
  },
  {
    to: '/audit',
    labelKey: 'nav.audit',
    icon: ScrollText,
    section: 'ops',
    superAdminOnly: true,
  },
]
